import * as criterias from 'atg/constants/CouponCriteria';
import { promiseRequest } from 'atg/utils/Request';

import * as types from '../actionTypes';
import { coupons } from '../selectors';

const requestCoupon = criteria => ({
  type: types.REQUEST_COUPON_URL,
  meta: { criteria },
});

const receiveCoupon = (criteria, url) => ({
  type: types.RECEIVE_COUPON_URL,
  meta: { criteria },
  payload: url,
});

const receiveCouponError = (criteria, error) => ({
  type: types.RECEIVE_COUPON_URL_ERROR,
  meta: { criteria, errorType: 'discrete' },
  payload: error,
});

// TODO Figure out how to refactor this to use redux-api-middlware
export const createCoupon = criteria => async (dispatch, getState) => {
  // Bail if already created
  if (coupons.getUrls(getState())[criteria]) {
    return;
  }

  dispatch(requestCoupon(criteria));

  let path = 'report/createCouponPDF';
  switch (criteria) {
    case criterias.CORRECT_ONLY:
      path += '/0';

      break;

    case criterias.MAX_ONE_ERROR:
      path += '/1';

      break;

    case criterias.MAX_TWO_ERRORS:
      path += '/2';

      break;

    default:
    // Do nothing
  }

  try {
    const pdfResponse = await promiseRequest({
      path,
    });

    const pdfUrl = await pdfResponse.text();

    if (pdfUrl) {
      dispatch(receiveCoupon(criteria, pdfUrl));
    } else {
      throw new Error('No response data');
    }
  } catch (error) {
    // Extract API error message if any
    try {
      const errorJson = await error.response.json();
      if (errorJson && errorJson.message) {
        error.message = errorJson.message;
      }
    } catch {
      // do nothing
    }
    dispatch(receiveCouponError(criteria, error));
  }
};

export const clearCoupons = () => ({
  type: types.CLEAR_COUPONS,
});
